module.exports = __webpack_public_path__ + "img/bq.51a33d9a.svg";